import { Bundle } from '@prisma/client';
import { Select, SelectProps } from 'antd';

import { Picker } from '@app/web-components';

import { useFindBundle } from '../../data';

export const BundlePicker = ({ style, ...props }: Omit<SelectProps, 'loading' | 'options'>) => {
  const { search, getSelectProps } = Picker.usePicker();
  const { data, isFetching, isPending } = useFindBundle<Bundle>({
    where: { name: { contains: search, mode: 'insensitive' }, isActive: true },
    select: { id: true, name: true },
    take: 50,
    skip: 0,
    orderBy: { name: 'asc' },
  });

  return (
    <Select
      {...getSelectProps({
        ...props,
        loading: isPending || isFetching,
        style: style ?? { width: '100%' },
        placeholder: props?.placeholder ?? 'Search by bundle name',
      })}
      options={data?.data.map((x) => ({ label: x.name, value: x.id }))}
    />
  );
};
